import { useQuery } from "@apollo/client";
import { Badge, Popover, Spinner } from "evergreen-ui";
import React from "react";
import { GET_ALL_PACKAGE_ORDERS } from "src/AdminRoutes/AdminRestockOrders/AdminRestockQueries";
import Message from "src/Message";
import { getDateWithTime } from "src/utilities";
import styled from "styled-components";
import RecordRow from "../RecordRow";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  height: 50vh;
  align-items: center;
  justify-content: center;
`;

const RowFooter = styled.div`
  display: flex;
  flex-direction: row;
`;
interface IProps {
  id: string;
}

const RestockHistory: React.SFC<IProps> = ({ id }) => {
  const { data, loading, error } = useQuery(GET_ALL_PACKAGE_ORDERS, {
    variables: {
      where: {
        buyer_id: { _eq: id },
      },
    },
  });
  return (
    <Container>
      {loading && (
        <LoadingContainer>
          <Spinner />
        </LoadingContainer>
      )}

      {!loading && error && <Message label={"Error: " + error.message} />}
      {!loading &&
        data &&
        data.allResults &&
        (data.allResults.length > 0 ? (
          data.allResults.map((pac, index) => (
            <RecordRow
              date={`ID: ${pac.id} | ${getDateWithTime(pac.created_at)}`}
              key={index}
              status={pac.status}
              item={
                pac.order_package.chinese_name + " | " + pac.order_package.name
              }
              figure={pac.quantity + " + " + pac.system_offer}
              footer={
                <RowFooter>
                  {pac.payment_slip ? (
                    <Popover
                      content={({ close }) => (
                        <img
                          onClick={() => {
                            close();
                          }}
                          style={{
                            maxWidth: "90vw",
                            objectFit: "contain",
                            maxHeight: "90vh",
                          }}
                          alt="Payment Slip"
                          src={pac.payment_slip}
                        />
                      )}
                    >
                      <Badge color="green">VIEW SLIP</Badge>
                    </Popover>
                  ) : (
                    <Badge color="yellow">UNPAID</Badge>
                  )}
                </RowFooter>
              }
            />
          ))
        ) : (
          <Message label="No record found" />
        ))}
    </Container>
  );
};

export default RestockHistory;
